<script lang="ts">
    import Footer from '../Footer.svelte'
    import Content from '../Content.svelte'
    import { createEventDispatcher } from 'svelte'

    interface Instruction {
        paragraphs: string[],
        warnings?: string[]
    }

    export let instructions: Instruction[]

    let step = 0

	const dispatch = createEventDispatcher();

    const done = () => {
        dispatch('done')
    }
</script>

<Content>
    <div class="content-horizontal-center content-vertical-center">
      <div class="w-l text-left">
        <h1>Instructions</h1>

        <div id={"instruction-step-" + instructions}>
            {#each instructions[step].paragraphs as paragraph}
                <p>{paragraph}</p>
            {/each}
            {#if instructions[step].warnings}
                {#each instructions[step].warnings as warning}
                    <p style="color: red;">{warning}</p>
                {/each}
            {/if}
            {#if step === instructions.length - 1}
                <button id="start-experiment-button" on:click={done}>
                    Débuter →
                </button>
            {/if}
        </div>
      </div>
    </div>
</Content>
<Footer>
    {#if step > 0}
        <button id="previous-instruction-button" on:click={() => {step--}}>Précédent</button>
    {/if}
    <div style="flex-grow:1"></div>
    {#if step < instructions.length - 1}
        <button id="next-instruction-button" on:click={()=>{step++}}>
        Suivant →
        </button>
    {/if}
</Footer>
